import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import {
  changeScreenOrientation,
  // updateDataSources
} from "../../../pages/Dashboard/HomeSevenScreen/7screen/redux/ScreensCommon/actions"

import debounce from 'lodash/debounce'

import { ScreenTitles } from "../ScreenTitles";
import { logActivity } from "pages/Dashboard/HomeSevenScreen/7screen/redux/api/loggingAPI";
import { UserActivityConstants } from "api/UserActivityConstants";
// import {
//   IconButton,
// } from "@mui/material";
// import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';

class SidebarContent extends React.Component {
  scrollToTab (tab) {
    // window.scrollTo(tab * 1920, 0)
    // scrollTo is the same
    window.scroll({
      top: this.props.orientationHorizontal ? 0 : tab * 1080, 
      left: this.props.orientationHorizontal ? tab * 1920 : 0, 
      behavior: 'smooth' 
    });

    // Log User Activity (Tab changes)

    logActivity({
      screen : UserActivityConstants.SIDEBAR.NAME,
      action_type : UserActivityConstants.ACTION_TYPES.CLICK,
      action_target : ScreenTitles[tab].title,
      action : UserActivityConstants.COMMON_ACTIONS.CHANGE_TAB
    }
    )
    this.props.onClose()
  }

  state = { screen: 1 }

  getCurrentScreen () {
    const x = window.pageXOffset
    const y = window.pageYOffset
    const screen = this.props.orientationHorizontal ? Math.round((x / 1920) + 1) : Math.round((y / 1080) + 1)
    this.setState({ screen })
  }

  componentDidMount () {
    this.getCurrentScreen()
    window.addEventListener('scroll', debounce(this.getCurrentScreen.bind(this), 200));
  }

  componentWillUnmount () {
    window.removeEventListener('scroll', debounce(this.getCurrentScreen.bind(this), 200));
  }

  // handleDataSourceToggle = () => {
  //   this.props.updateDataSources();
  // }

  render () {
    return (
      <div className='content-wrapper light'>
        <div className='items'>
          {ScreenTitles.map((s,i) => {
            const selected = this.state.screen === (i + 1)
            return (
              <div
                key={i}
                className={`item ${selected ? 'selected' : ''}`}
                onClick={() => this.scrollToTab(i)}
              >
                {/* <img className='media' alt="" src={selected ? s.selectedIcon : s.icon} /> */}
                <img className='media' alt="" src={s.icon} />
                {s.title}
              </div>  
            )
          })}
          {/* <IconButton
              id="data-sources-icon"
              style={{
                color: "white",
                marginLeft: 1770,
                marginTop: -15,
              }}
              onClick={this.handleDataSourceToggle}
            >
              <LibraryBooksIcon className="swap-icon" />
          </IconButton>
          <span 
            className="item"
            style={{
              position: "absolute",
              marginLeft: 1790,
              marginTop: 45
            }}
          >Data Sources</span> */}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    orientationHorizontal: state.ScreensCommonReducer.orientationHorizontal,
    // displayDataSources: state.ScreensCommonReducer.displayDataSources,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      changeScreenOrientation,
      // updateDataSources,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContent);